import { FormHelperText, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import "@material/react-text-field/dist/text-field.css";
import classNames from "classnames";
import debounce from "lodash.debounce";
import memoize from "lodash.memoize";
import reduce from "lodash.reduce";
import startsWith from "lodash.startswith";
import PropTypes from "prop-types";
import React from "react";
import { API_ENDPOINTS } from "../../../../util/constants";
import { TextWrap } from "../../../../util/showmore";
import CountryData from "./CountryData.js";
import "./utils/prototypes";
import Axios from "axios";
import * as helpers from "./../../../../util/helpers";

const classes = (theme) => ({
  searchRoot: {
    display: "flex",
    alignItems: "center",
    width: "90%",
    height: 43,
    backgroundColor2: "#f3f6f9",
    borderRadius: "4px",
    border: "solid 1px #ccd6e3",
    backgroundColor: "#f3f6f9",
    color: "#9d9db1",
    marginTop: "8px",
    marginBottom: "8px",
  },
  searchInput: {
    marginLeft: 4,
    flex: 1,
    lineHeight: "2em",
    minWidth: "80%",
  },
  searchIconButton: {
    padding: 10,
  },
  searchDivider: {
    width: 1,
    height: 28,
    margin: 4,
  },

  root: {
    color: "#9d9db1",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#f3f6f9",
    transition2: theme.transitions.create(["border-color", "box-shadow"]),

    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&:hover2": {
      backgroundColor: "#f3f6f9",
    },
    "&$focused": {
      backgroundColor: "#f3f6f9",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f3f6f9",
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#9d9db1",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(16px, -8px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      backgroundColor: "transparent",
    },
  },

  rootFilled: {
    color: "#1f4a94",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    transition2: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
      borderColor: theme.palette.primary.main,
    },

    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#1f4a94",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
  },

  rootEror: {
    color: "#ff0707",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    transition2: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
      borderColor: theme.palette.primary.main,
    },

    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#ff0707",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#ff0707",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
  },

  rootNarrow: {
    color: "#9d9db1",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#f3f6f9",
    transition2: theme.transitions.create(["border-color", "box-shadow"]),

    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&:hover2": {
      backgroundColor: "#f3f6f9",
    },
    "&$focused": {
      backgroundColor: "#f3f6f9",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f3f6f9",
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#9d9db1",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 14px",
    },
  },

  rootFilledNarrow: {
    color: "#1f4a94",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    transition2: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
      borderColor: theme.palette.primary.main,
    },

    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#1f4a94",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 14px",
    },
  },

  rootErorNarrow: {
    color: "#ff0707",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    transition2: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#ff0707",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#ff0707",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 14px",
    },
  },
  focused: {},
});

class PhoneInput extends React.Component {
  static propTypes = {
    country: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    validStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.string,
    onlyCountries: PropTypes.arrayOf(PropTypes.string),
    preferredCountries: PropTypes.arrayOf(PropTypes.string),
    excludeCountries: PropTypes.arrayOf(PropTypes.string),
    placeholder: PropTypes.string,
    searchPlaceholder: PropTypes.string,
    searchNotFound: PropTypes.string,
    disabled: PropTypes.bool,
    containerStyle: PropTypes.object,
    style: PropTypes.object,
    inputStyle: PropTypes.object,
    buttonStyle: PropTypes.object,
    dropdownStyle: PropTypes.object,
    searchStyle: PropTypes.object,
    containerClass: PropTypes.string,
    inputClass: PropTypes.string,
    buttonClass: PropTypes.string,
    dropdownClass: PropTypes.string,
    searchClass: PropTypes.string,
    autoFormat: PropTypes.bool,
    enableAreaCodes: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    enableTerritories: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    disableCountryCode: PropTypes.bool,
    disableDropdown: PropTypes.bool,
    enableLongNumbers: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    countryCodeEditable: PropTypes.bool,
    enableSearch: PropTypes.bool,
    disableSearchIcon: PropTypes.bool,
    disableInitialCountryGuess: PropTypes.bool,
    disableCountryGuess: PropTypes.bool,
    regions: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    inputProps: PropTypes.object,
    localization: PropTypes.object,
    masks: PropTypes.object,
    areaCodes: PropTypes.object,
    preserveOrder: PropTypes.arrayOf(PropTypes.string),
    defaultMask: PropTypes.string,
    alwaysDefaultMask: PropTypes.bool,
    prefix: PropTypes.string,
    copyNumbersOnly: PropTypes.bool,
    renderStringAsFlag: PropTypes.string,
    autocompleteSearch: PropTypes.bool,
    jumpCursorToEnd: PropTypes.bool,
    priority: PropTypes.object,
    enableAreaCodeStretch: PropTypes.bool,
    enableClickOutside: PropTypes.bool,
    showDropdown: PropTypes.bool,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    onEnterKeyPress: PropTypes.func,
    isValid: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    defaultErrorMessage: PropTypes.string,
    specialLabel: PropTypes.string,
  };

  static defaultProps = {
    country: "",
    value: "",
    onlyCountries: [],
    preferredCountries: [],
    excludeCountries: [],
    placeholder: "1 (702) 123-4567",
    searchPlaceholder: "search",
    searchNotFound: "No entries to show",
    flagsImagePath: "./flags.png",
    disabled: false,
    containerStyle: {},
    inputStyle: {},
    buttonStyle: {},
    dropdownStyle: {},
    searchStyle: {},
    containerClass: "",
    inputClass: "",
    buttonClass: "",
    dropdownClass: "",
    searchClass: "",
    autoFormat: true,
    enableAreaCodes: false,
    enableTerritories: false,
    disableCountryCode: false,
    disableDropdown: false,
    enableLongNumbers: false,
    countryCodeEditable: true,
    enableSearch: false,
    disableSearchIcon: false,
    disableInitialCountryGuess: false,
    disableCountryGuess: false,
    regions: "",
    inputProps: {},
    localization: {},
    masks: null,
    priority: null,
    areaCodes: null,
    preserveOrder: [],
    defaultMask: "... ... ... ... ..",
    alwaysDefaultMask: false,
    prefix: "", //+',
    copyNumbersOnly: true,
    renderStringAsFlag: "",
    autocompleteSearch: false,
    jumpCursorToEnd: true,
    enableAreaCodeStretch: false,
    enableClickOutside: true,
    showDropdown: false,
    isValid: true,
    defaultErrorMessage: "",
    specialLabel: "Phone",
    onEnterKeyPress: null,
    keys: {
      UP: 38,
      DOWN: 40,
      RIGHT: 39,
      LEFT: 37,
      ENTER: 13,
      ESC: 27,
      PLUS: 43,
      A: 65,
      Z: 90,
      SPACE: 32,
      TAB: 9,
    },
  };

  constructor(props) {
    super(props);
    const {
      onlyCountries,
      preferredCountries,
      hiddenAreaCodes,
    } = new CountryData(
      props.enableAreaCodes,
      props.enableTerritories,
      props.regions,
      props.onlyCountries,
      props.preferredCountries,
      props.excludeCountries,
      props.preserveOrder,
      props.masks,
      props.priority,
      props.areaCodes,
      props.localization,
      props.prefix,
      props.defaultMask,
      props.alwaysDefaultMask
    );
    const inputNumber = props.value ? props.value.replace(/\D/g, "") : "";
    let countryGuess;
    if (props.disableInitialCountryGuess) {
      countryGuess = 0;
    } else if (inputNumber.length > 1) {
      countryGuess =
        this.guessSelectedCountry(
          inputNumber.substring(0, 6),
          props.country,
          onlyCountries,
          hiddenAreaCodes
        ) || 0;
    } else if (props.country) {
      countryGuess = onlyCountries.find((o) => o.iso2 === props.country) || 0;
    } else {
      countryGuess = 0;
    }

    let formattedNumber;
    formattedNumber =
      inputNumber === "" && countryGuess === 0
        ? ""
        : inputNumber && countryGuess
        ? inputNumber.substring(countryGuess.dialCode.length)
        : inputNumber;
    const highlightCountryIndex = onlyCountries.findIndex(
      (o) => o === countryGuess
    );

    this.state = {
      showDropdown: props.showDropdown,

      formattedNumber,
      onlyCountries,
      preferredCountries,
      hiddenAreaCodes,
      selectedCountry: countryGuess,
      highlightCountryIndex,

      queryString: "",
      freezeSelection: false,
      debouncedQueryStingSearcher: debounce(this.searchCountry, 250),
      searchValue: "",
    };
  }

  componentDidMount() {
    if (document.addEventListener && this.props.enableClickOutside) {
      document.addEventListener("mousedown", this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (document.removeEventListener && this.props.enableClickOutside) {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.country !== this.props.country) {
      this.updateCountry(this.props.country);
    } else if (prevProps.value !== this.props.value) {
      this.updateFormattedNumber(this.props.value);
    }
  }

  getProbableCandidate = memoize((queryString) => {
    if (!queryString || queryString.length === 0) {
      return null;
    }
    const probableCountries = this.state.onlyCountries.filter((country) => {
      return startsWith(country.name.toLowerCase(), queryString.toLowerCase());
    }, this);
    return probableCountries[0];
  });

  guessSelectedCountry = memoize(
    (inputNumber, country, onlyCountries, hiddenAreaCodes) => {
      if (this.props.enableAreaCodes === false) {
        let mainCode;
        hiddenAreaCodes.some((country) => {
          if (startsWith(inputNumber, country.dialCode)) {
            onlyCountries.some((o) => {
              if (country.iso2 === o.iso2 && o.mainCode) {
                mainCode = o;
                return true;
              }
            });
            return true;
          }
        });
        if (mainCode) return mainCode;
      }

      const secondBestGuess = onlyCountries.find((o) => o.iso2 === country);
      if (inputNumber.trim() === "") return secondBestGuess;

      const bestGuess = onlyCountries.reduce(
        (selectedCountry, country) => {
          if (startsWith(inputNumber, country.dialCode)) {
            if (country.dialCode.length > selectedCountry.dialCode.length) {
              return country;
            }
            if (
              country.dialCode.length === selectedCountry.dialCode.length &&
              country.priority < selectedCountry.priority
            ) {
              return country;
            }
          }
          return selectedCountry;
        },
        { dialCode: "", priority: 10001 },
        this
      );

      if (!bestGuess.name) return secondBestGuess;
      return bestGuess;
    }
  );

  updateCountry = (country) => {
    const { onlyCountries } = this.state;
    let newSelectedCountry;
    if (country.indexOf(0) >= "0" && country.indexOf(0) <= "9") {
      newSelectedCountry = onlyCountries.find((o) => o.dialCode === +country);
    } else {
      newSelectedCountry = onlyCountries.find((o) => o.iso2 === country);
    }
    if (newSelectedCountry && newSelectedCountry.dialCode) {
      this.setState({
        selectedCountry: newSelectedCountry,
        formattedNumber: this.props.disableCountryCode
          ? ""
          : this.formatNumber(newSelectedCountry.dialCode, newSelectedCountry),
      });
    }
  };

  updateFormattedNumber(value) {
    if (value === null)
      return this.setState({ selectedCountry: 0, formattedNumber: "" });

    const { onlyCountries, selectedCountry, hiddenAreaCodes } = this.state;
    const { country, prefix } = this.props;

    if (value === "")
      return this.setState({ selectedCountry, formattedNumber: "" });

    let inputNumber = value.replace(/\D/g, "");
    let newSelectedCountry, formattedNumber;

    if (
      selectedCountry &&
      startsWith(value, prefix + selectedCountry.dialCode)
    ) {
      formattedNumber = this.formatNumber(inputNumber, selectedCountry);
      this.setState({ formattedNumber });
    } else {
      if (this.props.disableCountryGuess) {
        newSelectedCountry = selectedCountry;
      } else {
        newSelectedCountry =
          this.guessSelectedCountry(
            inputNumber.substring(0, 6),
            country,
            onlyCountries,
            hiddenAreaCodes
          ) || selectedCountry;
      }
      const dialCode =
        newSelectedCountry &&
        startsWith(inputNumber, prefix + newSelectedCountry.dialCode)
          ? newSelectedCountry.dialCode
          : "";

      formattedNumber = this.formatNumber(
        (this.props.disableCountryCode ? "" : dialCode) + inputNumber,
        newSelectedCountry ? newSelectedCountry : undefined
      );
      this.setState({ selectedCountry: newSelectedCountry, formattedNumber });
    }
  }

  scrollTo = (country, middle) => {
    if (!country) return;
    const container = this.dropdownRef;
    if (!container || !document.body) return;

    const containerHeight = container.offsetHeight;
    const containerOffset = container.getBoundingClientRect();
    const containerTop = containerOffset.top + document.body.scrollTop;
    const containerBottom = containerTop + containerHeight;

    const element = country;
    const elementOffset = element.getBoundingClientRect();

    const elementHeight = element.offsetHeight;
    const elementTop = elementOffset.top + document.body.scrollTop;
    const elementBottom = elementTop + elementHeight;

    let newScrollTop = elementTop - containerTop + container.scrollTop;
    const middleOffset = containerHeight / 2 - elementHeight / 2;

    if (
      this.props.enableSearch
        ? elementTop < containerTop + 32
        : elementTop < containerTop
    ) {
      if (middle) {
        newScrollTop -= middleOffset;
      }
      container.scrollTop = newScrollTop;
    } else if (elementBottom > containerBottom) {
      if (middle) {
        newScrollTop += middleOffset;
      }
      const heightDifference = containerHeight - elementHeight;
      container.scrollTop = newScrollTop - heightDifference;
    }
  };

  scrollToTop = () => {
    const container = this.dropdownRef;
    if (!container || !document.body) return;
    container.scrollTop = 0;
  };

  formatNumber = (text, country) => {
    if (!country) return text;

    const { format } = country;
    const {
      disableCountryCode,
      enableAreaCodeStretch,
      enableLongNumbers,
      autoFormat,
    } = this.props;

    let pattern;
    if (disableCountryCode) {
      pattern = format.split(" ");
      pattern.shift();
      pattern = pattern.join(" ");
    } else {
      if (enableAreaCodeStretch && country.isAreaCode) {
        pattern = format.split(" ");
        pattern[1] = pattern[1].replace(
          /\.+/,
          "".padEnd(country.areaCodeLength, ".")
        );
        pattern = pattern.join(" ");
      } else {
        pattern = format;
      }
    }

    if (!text || text.length === 0) {
      return disableCountryCode ? "" : this.props.prefix;
    }

    if ((text && text.length < 2) || !pattern || !autoFormat) {
      return disableCountryCode ? text : this.props.prefix + text;
    }

    const formattedObject = reduce(
      pattern,
      (acc, character) => {
        if (acc.remainingText.length === 0) {
          return acc;
        }

        if (character !== ".") {
          return {
            formattedText: acc.formattedText + character,
            remainingText: acc.remainingText,
          };
        }

        const [head, ...tail] = acc.remainingText;

        return {
          formattedText: acc.formattedText + head,
          remainingText: tail,
        };
      },
      {
        formattedText: "",
        remainingText: text.split(""),
      }
    );

    let formattedNumber;
    if (enableLongNumbers) {
      formattedNumber =
        formattedObject.formattedText + formattedObject.remainingText.join("");
    } else {
      formattedNumber = formattedObject.formattedText;
    }

    if (formattedNumber.includes("(") && !formattedNumber.includes(")"))
      formattedNumber += ")";
    return formattedNumber;
  };

  cursorToEnd = () => {
    const input = this.numberInputRef;
    input.focus();
    let len = input.value.length;
    if (input.value.charAt(len - 1) === ")") len = len - 1;
    input.setSelectionRange(len, len);
  };

  getElement = (index) => {
    return this[`flag_no_${index}`];
  };

  getCountryData = () => {
    if (!this.state.selectedCountry) return {};
    return {
      name: this.state.selectedCountry.name || "",
      dialCode: this.state.selectedCountry.dialCode || "",
      countryCode: this.state.selectedCountry.iso2 || "",
      format: this.state.selectedCountry.format || "",
    };
  };

  handleFlagDropdownClick = (e) => {
    e.preventDefault();
    if (this.props.readOnly) return;
    if (!this.state.showDropdown && this.props.disabled) return;
    const { preferredCountries, selectedCountry } = this.state;
    const allCountries = preferredCountries.concat(this.state.onlyCountries);

    const highlightCountryIndex = allCountries.findIndex(
      (o) =>
        o.dialCode === selectedCountry.dialCode &&
        o.iso2 === selectedCountry.iso2
    );

    this.setState(
      {
        showDropdown: !this.state.showDropdown,
        highlightCountryIndex,
      },
      () => {
        if (this.state.showDropdown) {
          this.scrollTo(this.getElement(this.state.highlightCountryIndex));
        }
      }
    );
  };

  handleInput = (e) => {
    const { value } = e.target;
    const { prefix, onChange } = this.props;

    let formattedNumber = this.props.disableCountryCode ? "" : prefix;
    let newSelectedCountry = this.state.selectedCountry;
    let freezeSelection = this.state.freezeSelection;

    if (!this.props.countryCodeEditable) {
      const mainCode = newSelectedCountry.hasAreaCodes
        ? this.state.onlyCountries.find(
            (o) => o.iso2 === newSelectedCountry.iso2 && o.mainCode
          ).dialCode
        : newSelectedCountry.dialCode;

      const updatedInput = prefix + mainCode;
      if (value.slice(0, updatedInput.length) !== updatedInput) return;
    }

    if (value === prefix) {
      if (onChange) onChange("", this.getCountryData(), e, "");
      return this.setState({ formattedNumber: "" });
    }

    if (value.replace(/\D/g, "").length > 15) {
      if (this.props.enableLongNumbers === false) return;
      if (typeof this.props.enableLongNumbers === "number") {
        if (value.replace(/\D/g, "").length > this.props.enableLongNumbers)
          return;
      }
    }

    if (value === this.state.formattedNumber) return;

    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }

    const { country } = this.props;
    const { onlyCountries, selectedCountry, hiddenAreaCodes } = this.state;

    if (onChange) e.persist();

    if (value.length > 0) {
      const inputNumber = value.replace(/\D/g, "");
      if (
        !this.state.freezeSelection ||
        selectedCountry.dialCode.length > inputNumber.length
      ) {
        if (this.props.disableCountryGuess) {
          newSelectedCountry = selectedCountry;
        } else {
          newSelectedCountry =
            this.guessSelectedCountry(
              inputNumber.substring(0, 6),
              country,
              onlyCountries,
              hiddenAreaCodes
            ) || selectedCountry;
        }
        freezeSelection = false;
      }
      formattedNumber = this.formatNumber(inputNumber, newSelectedCountry);
      newSelectedCountry = newSelectedCountry.dialCode
        ? newSelectedCountry
        : selectedCountry;
    }

    let caretPosition = e.target.selectionStart;
    const oldFormattedText = this.state.formattedNumber;
    const diff = formattedNumber.length - oldFormattedText.length;

    this.setState(
      {
        formattedNumber,
        freezeSelection,
        selectedCountry: newSelectedCountry,
      },
      () => {
        if (diff > 0) {
          caretPosition = caretPosition - diff;
        }

        const lastChar = formattedNumber.charAt(formattedNumber.length - 1);

        if (lastChar === ")") {
          this.numberInputRef.setSelectionRange(
            formattedNumber.length - 1,
            formattedNumber.length - 1
          );
        } else if (
          caretPosition > 0 &&
          oldFormattedText.length >= formattedNumber.length
        ) {
          this.numberInputRef.setSelectionRange(caretPosition, caretPosition);
        }
        let n = formattedNumber;
        n = n.replaceAll(" ", "");
        n = n.replaceAll("-", "");
        n = n.replaceAll(")", "");
        n = n.replaceAll("(", "");
        if (onChange) onChange(n, this.getCountryData(), e, formattedNumber);
      }
    );
  };

  handleInputClick = (e) => {
    this.setState({ showDropdown: false });
    if (this.props.onClick) this.props.onClick(e, this.getCountryData());
  };

  handleDoubleClick = (e) => {
    const len = e.target.value.length;
    e.target.setSelectionRange(0, len);
  };

  handleFlagItemClick = async (country, e) => {
    const currentSelectedCountry = this.state.selectedCountry;
    const newSelectedCountry = this.state.onlyCountries.find(
      (o) => o === country
    );
    if (!newSelectedCountry) return;

    const unformattedNumber = this.state.formattedNumber
      .replace(" ", "")
      .replace("(", "")
      .replace(")", "")
      .replace("-", "");
    const newNumber1 =
      unformattedNumber.length > 1
        ? unformattedNumber.replace(
            currentSelectedCountry.dialCode,
            newSelectedCountry.dialCode
          )
        : newSelectedCountry.dialCode;

    const newNumber = unformattedNumber;
    const formattedNumber1 = this.formatNumber(
      newNumber.replace(/\D/g, ""),
      newSelectedCountry
    );
    const formattedNumber = unformattedNumber;
    var bodyFormData = new FormData();
    bodyFormData.append("country", country.iso2);
    bodyFormData.append("countryCode", `+${country.dialCode}`);
    const response = await Axios({
      method: "post",
      url: API_ENDPOINTS.getLastSavedCountryCodeSet,
      data: bodyFormData,
      headers: {
        "Content-Type": `multipart/form-data;`,
      },
    });

    this.setState(
      {
        showDropdown: false,
        selectedCountry: newSelectedCountry,
        freezeSelection: true,
        formattedNumber,
        unformattedNumber,
      },
      () => {
        this.cursorToEnd();
        if (this.props.onChange)
          this.props.onChange(
            formattedNumber.replace(/[^0-9]+/g, ""),
            this.getCountryData(),
            e,
            formattedNumber
          );
      }
    );
  };

  handleInputFocus = (e) => {
    if (this.numberInputRef) {
      if (
        this.numberInputRef.value === this.props.prefix &&
        this.state.selectedCountry &&
        !this.props.disableCountryCode
      ) {
        this.setState(
          {
            formattedNumber:
              this.props.prefix + this.state.selectedCountry.dialCode,
          },
          () => {
            this.props.jumpCursorToEnd && setTimeout(this.cursorToEnd, 0);
          }
        );
      }
    }

    this.setState({ placeholder: "" });

    this.props.onFocus && this.props.onFocus(e, this.getCountryData());
    this.props.jumpCursorToEnd && setTimeout(this.cursorToEnd, 0);
  };

  handleInputBlur = (e) => {
    if (!e.target.value) this.setState({ placeholder: this.props.placeholder });
    this.props.onBlur && this.props.onBlur(e, this.getCountryData());
  };

  handleInputCopy = (e) => {
    if (!this.props.copyNumbersOnly) return;
    const text = window
      .getSelection()
      .toString()
      .replace(/[^0-9]+/g, "");
    e.clipboardData.setData("text/plain", text);
    e.preventDefault();
  };

  getHighlightCountryIndex = (direction) => {
    const highlightCountryIndex = this.state.highlightCountryIndex + direction;

    if (
      highlightCountryIndex < 0 ||
      highlightCountryIndex >=
        this.state.onlyCountries.length + this.state.preferredCountries.length
    ) {
      return highlightCountryIndex - direction;
    }

    if (
      this.props.enableSearch &&
      highlightCountryIndex > this.getSearchFilteredCountries().length
    )
      return 0; // select first country
    return highlightCountryIndex;
  };

  searchCountry = () => {
    const probableCandidate =
      this.getProbableCandidate(this.state.queryString) ||
      this.state.onlyCountries[0];
    const probableCandidateIndex =
      this.state.onlyCountries.findIndex((o) => o === probableCandidate) +
      this.state.preferredCountries.length;

    this.scrollTo(this.getElement(probableCandidateIndex), true);

    this.setState({
      queryString: "",
      highlightCountryIndex: probableCandidateIndex,
    });
  };

  handleKeydown = (e) => {
    const { keys } = this.props;
    const {
      target: { className },
    } = e;

    if (
      className.includes("selected-flag") &&
      e.which === keys.ENTER &&
      !this.state.showDropdown
    )
      return this.handleFlagDropdownClick(e);
    if (
      className.includes("form-control") &&
      (e.which === keys.ENTER || e.which === keys.ESC)
    )
      return e.target.blur();

    if (!this.state.showDropdown || this.props.disabled) return;
    if (className.includes("search-box")) {
      if (
        e.which !== keys.UP &&
        e.which !== keys.DOWN &&
        e.which !== keys.ENTER
      ) {
        if (e.which === keys.ESC && e.target.value === "") {
        } else {
          return;
        }
      }
    }

    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }

    const moveHighlight = (direction) => {
      this.setState(
        {
          highlightCountryIndex: this.getHighlightCountryIndex(direction),
        },
        () => {
          this.scrollTo(
            this.getElement(this.state.highlightCountryIndex),
            true
          );
        }
      );
    };

    switch (e.which) {
      case keys.DOWN:
        moveHighlight(1);
        break;
      case keys.UP:
        moveHighlight(-1);
        break;
      case keys.ENTER:
        if (this.props.enableSearch) {
          this.handleFlagItemClick(
            this.getSearchFilteredCountries()[
              this.state.highlightCountryIndex
            ] || this.getSearchFilteredCountries()[0],
            e
          );
        } else {
          this.handleFlagItemClick(
            [...this.state.preferredCountries, ...this.state.onlyCountries][
              this.state.highlightCountryIndex
            ],
            e
          );
        }
        break;
      case keys.ESC:
      case keys.TAB:
        this.setState(
          {
            showDropdown: false,
          },
          this.cursorToEnd
        );
        break;
      default:
        if (
          (e.which >= keys.A && e.which <= keys.Z) ||
          e.which === keys.SPACE
        ) {
          this.setState(
            {
              queryString:
                this.state.queryString + String.fromCharCode(e.which),
            },
            this.state.debouncedQueryStingSearcher
          );
        }
    }
  };

  handleInputKeyDown = (e) => {
    const { keys, onEnterKeyPress, onKeyDown } = this.props;
    if (e.which === keys.ENTER) {
      if (onEnterKeyPress) onEnterKeyPress(e);
    }
    if (onKeyDown) onKeyDown(e);
  };

  handleClickOutside = (e) => {
    if (this.dropdownRef && !this.dropdownContainerRef.contains(e.target)) {
      this.state.showDropdown && this.setState({ showDropdown: false });
    }
  };

  handleSearchChange = (e) => {
    const {
      currentTarget: { value: searchValue },
    } = e;
    const { preferredCountries, selectedCountry } = this.state;
    let highlightCountryIndex = 0;

    if (searchValue === "" && selectedCountry) {
      const { onlyCountries } = this.state;
      highlightCountryIndex = preferredCountries
        .concat(onlyCountries)
        .findIndex((o) => o === selectedCountry);
      setTimeout(
        () => this.scrollTo(this.getElement(highlightCountryIndex)),
        100
      );
    }
    this.setState({ searchValue, highlightCountryIndex });
  };

  getDropdownCountryName = (country) => {
    return country.localName || country.name;
  };

  getSearchFilteredCountries = () => {
    const { preferredCountries, onlyCountries, searchValue } = this.state;
    const { enableSearch } = this.props;
    const allCountries = preferredCountries.concat(onlyCountries);
    const sanitizedSearchValue = searchValue.trim().toLowerCase();
    if (enableSearch && sanitizedSearchValue) {
      if (/^\d+$/.test(sanitizedSearchValue)) {
        return allCountries.filter(({ dialCode }) =>
          [`${dialCode}`].some((field) =>
            field.toLowerCase().includes(sanitizedSearchValue)
          )
        );
      } else {
        const iso2countries = allCountries.filter(({ iso2 }) =>
          [`${iso2}`].some((field) =>
            field.toLowerCase().includes(sanitizedSearchValue)
          )
        );
        const searchedCountries = allCountries.filter(
          ({ name, localName, iso2 }) =>
            [`${name}`, `${localName || ""}`].some((field) =>
              field.toLowerCase().includes(sanitizedSearchValue)
            )
        );
        this.scrollToTop();
        return [...new Set([].concat(iso2countries, searchedCountries))];
      }
    } else {
      return allCountries;
    }
  };

  getCountryDropdownList = () => {
    const {
      preferredCountries,
      highlightCountryIndex,
      showDropdown,
      searchValue,
    } = this.state;
    const { disableDropdown, prefix } = this.props;
    const {
      enableSearch,
      searchNotFound,
      disableSearchIcon,
      searchClass,
      searchStyle,
      searchPlaceholder,
      autocompleteSearch,
    } = this.props;

    const searchedCountries = this.getSearchFilteredCountries();

    let countryDropdownList = searchedCountries.map((country, index) => {
      if (helpers.isFeatureEnabledProfile('is_ksa_cluster') && country.iso2 === "pk") {
        country.disabled = false;
      }
      const highlight = highlightCountryIndex === index;
      const itemClasses = classNames({
        country: true,
        preferred: country.iso2 === "us" || country.iso2 === "gb",
        active: country.iso2 === "us",
        disabled: country.disabled,
        highlight,
      });

      const inputFlagClasses = `flag ${country.iso2}`;

      return (
        <li
          ref={(el) => (this[`flag_no_${index}`] = el)}
          key={`flag_no_${index}`}
          data-flag-key={`flag_no_${index}`}
          className={itemClasses}
          data-dial-code="1"
          tabIndex={disableDropdown ? "-1" : "0"}
          data-country-code={country.iso2}
          onClick={
            !country.disabled
              ? (e) => this.handleFlagItemClick(country, e)
              : () => {}
          }
          role="option"
          {...(highlight ? { "aria-selected": true } : {})}
          style={{ opacity: country.disabled ? "0.5" : "1" }}
          title={
            country.disabled
              ? "To activate calling to this country. Please contact support@knowlarity.com"
              : this.getDropdownCountryName(country)
          }
        >
          <div className={inputFlagClasses} />

          <span className="dial-code">
            {country.format
              ? this.formatNumber(country.dialCode, country)
              : prefix + country.dialCode}
          </span>
          <span className="country-name">
            <TextWrap text={this.getDropdownCountryName(country)} max={20} />
          </span>
        </li>
      );
    });

    const dashedLi = <li key={"dashes"} className="divider" />;
    preferredCountries.length > 0 &&
      (!enableSearch || (enableSearch && !searchValue.trim())) &&
      countryDropdownList.splice(preferredCountries.length, 0, dashedLi);

    const dropDownClasses = classNames({
      [this.props.dropdownClass]: true,
      "country-list": true,
      hide: !showDropdown,
    });

    return (
      <ul
        ref={(el) => {
          !enableSearch && el && el.focus();
          return (this.dropdownRef = el);
        }}
        className={dropDownClasses}
        style={this.props.dropdownStyle}
        role="listbox"
        tabIndex="0"
      >
        {enableSearch && (
          <li
            className={classNames({
              search: true,
              [searchClass]: searchClass,
            })}
          >
            {!disableSearchIcon && (
              <span
                className={classNames({
                  "search-emoji": true,
                  [`${searchClass}-emoji`]: searchClass,
                })}
                role="img"
                aria-label="Magnifying glass"
              >
                &#128270;
              </span>
            )}
            <input
              className={classNames({
                "search-box": true,
                [`${searchClass}-box`]: searchClass,
              })}
              style={searchStyle}
              type="search"
              placeholder={searchPlaceholder}
              autoFocus={true}
              autoComplete={autocompleteSearch ? "on" : "off"}
              value={searchValue}
              onChange={this.handleSearchChange}
            />
          </li>
        )}
        {countryDropdownList.length > 0 ? (
          countryDropdownList
        ) : (
          <li className="no-entries-message">
            <span>{searchNotFound}</span>
          </li>
        )}
      </ul>
    );
  };

  render() {
    const {
      onlyCountries,
      selectedCountry,
      showDropdown,
      formattedNumber,
      hiddenAreaCodes,
    } = this.state;
    const {
      disableDropdown,
      renderStringAsFlag,
      isValid,
      defaultErrorMessage,
      specialLabel,
    } = this.props;

    let isValidValue, errorMessage;
    if (typeof isValid === "boolean") {
      isValidValue = isValid;
    } else {
      const isValidProcessed = isValid(
        formattedNumber.replace(/\D/g, ""),
        selectedCountry,
        onlyCountries,
        hiddenAreaCodes
      );
      if (typeof isValidProcessed === "boolean") {
        isValidValue = isValidProcessed;
        if (isValidValue === false) errorMessage = defaultErrorMessage;
      } else {
        isValidValue = false;
        errorMessage = isValidProcessed;
      }
    }

    const containerClasses = classNames({
      [this.props.containerClass]: true,
      "react-tel-input": true,
    });
    const arrowClasses = classNames({ arrow: true, up: showDropdown });
    const selectedFlagClasses = classNames({
      "selected-flag": true,
      open: showDropdown,
    });
    const flagViewClasses = classNames({
      [this.props.buttonClass]: true,
      "flag-dropdown": true,
      "invalid-number": !isValidValue,
      open: showDropdown,
    });
    const inputFlagClasses = `flag ${selectedCountry && selectedCountry.iso2}`;

    const selectText = (e) => {
      if (!e || !e.target || !e.target.value) return;
      const len = e.target.value.length;
      e.target.setSelectionRange(0, len);
    };

    return (
      <>
        {this.props.componentType === "narrow" ? (
          <div
            className={containerClasses}
            style={this.props.style || this.props.containerStyle}
            onKeyDown={this.handleKeydown}
          >
            {specialLabel && (
              <div className="special-label">{specialLabel}</div>
            )}
            {errorMessage && (
              <div className="invalid-number-message">{errorMessage}</div>
            )}

            <TextField
              onChange={this.handleInput}
              onDoubleClick={selectText}
              onFocus={this.handleInputFocus}
              onBlur={this.handleInputBlur}
              onCopy={this.handleInputCopy}
              value={formattedNumber ? formattedNumber : this.props.value}
              label={this.props.label ? this.props.label : "Customer Number"}
              disabled={this.props.readOnly}
              variant="outlined"
              fullWidth
              style={{}}
              autoFocus={false}
              className={
                this.props.validStatus === 402 ||
                this.props.validStatus === 400 ||
                this.props.validStatus === 403
                  ? this.props.classes.rootErorNarrow
                  : !this.props.readOnly &&
                    formattedNumber &&
                    formattedNumber !== ""
                  ? this.props.classes.rootFilledNarrow
                  : this.props.classes.rootNarrow
              }
              InputProps={{
                readOnly: this.props.readOnly,
                classes2: this.props.classes,
                disableUnderline: true,
                startAdornment: this.props.startAdornment ? (
                  <>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        fontSize: "13px",
                        backgroundColor: "yellow-no",
                        fontWeight: "600",
                      }}
                    >
                      <div
                        className={flagViewClasses}
                        styledd={this.props.buttonStyle}
                        style={{
                          position: "relative",
                          float: "left",
                          marginRight: "12px",
                          borderRadius: "4px",
                          border: "0px solid rgb(31, 74, 148)",
                          backgroundColor: "transparent",
                          display: "flex",
                          alignItems: "center",
                          minWidth: "35px",
                          justifyContent: "center",
                          width: "29px",
                          height: "18px",
                          fontSize: "11px",
                          fontWeight: "600",
                        }}
                        ref={(el) => (this.dropdownContainerRef = el)}
                      >
                        {renderStringAsFlag ? (
                          <div className={selectedFlagClasses}>
                            {renderStringAsFlag}
                          </div>
                        ) : (
                          <div
                            onClick={
                              disableDropdown
                                ? undefined
                                : this.handleFlagDropdownClick
                            }
                            className={`${selectedFlagClasses} ${
                              this.props.readOnly ? "readonly" : "feditable"
                            }`}
                            title={
                              selectedCountry
                                ? `${selectedCountry.name}: + ${selectedCountry.dialCode}`
                                : ""
                            }
                            tabIndex={
                              this.props.readOnly || disableDropdown
                                ? "-1"
                                : "0"
                            }
                            role="button"
                            aria-haspopup="listbox"
                            aria-expanded={
                              !this.props.readOnly && showDropdown
                                ? true
                                : undefined
                            }
                          >
                            <div className={inputFlagClasses}>
                              {<div className={arrowClasses}></div>}
                            </div>
                          </div>
                        )}

                        {showDropdown && this.getCountryDropdownList()}
                      </div>
                      <span className="dial-code-text">
                        {this.props.startAdornment} +{selectedCountry.dialCode}
                      </span>
                    </span>
                  </>
                ) : (
                  <span>+{selectedCountry.dialCode}</span>
                ),
              }}
              inputRef={(el) => (this.numberInputRef = el)}
              color="primary"
              autoComplete="off"
              name={"customer_number"}
            ></TextField>
          </div>
        ) : (
          <div
            className={containerClasses}
            style={this.props.style || this.props.containerStyle}
            onKeyDown={this.handleKeydown}
          >
            {specialLabel && (
              <div className="special-label">{specialLabel}</div>
            )}
            {errorMessage && (
              <div className="invalid-number-message">{errorMessage}</div>
            )}

            <div
              className={flagViewClasses}
              style={this.props.buttonStyle}
              ref={(el) => (this.dropdownContainerRef = el)}
            >
              {renderStringAsFlag ? (
                <div className={selectedFlagClasses}>{renderStringAsFlag}</div>
              ) : (
                <div
                  onClick={
                    disableDropdown ? undefined : this.handleFlagDropdownClick
                  }
                  className={`${selectedFlagClasses} ${
                    this.props.readOnly ? "readonly" : "feditable"
                  }`}
                  title={
                    selectedCountry
                      ? `${selectedCountry.name}: + ${selectedCountry.dialCode}`
                      : ""
                  }
                  tabIndex={this.props.readOnly || disableDropdown ? "-1" : "0"}
                  role="button"
                  aria-haspopup="listbox"
                  aria-expanded={
                    !this.props.readOnly && showDropdown ? true : undefined
                  }
                >
                  <div className={inputFlagClasses}>
                    {!this.props.readOnly && !disableDropdown && (
                      <div className={arrowClasses}></div>
                    )}
                  </div>
                </div>
              )}

              {showDropdown && this.getCountryDropdownList()}
            </div>

            <div style={{ width: "100%" }}>
              <TextField
                onChange={this.handleInput}
                onDoubleClick={selectText}
                onFocus={this.handleInputFocus}
                onBlur={this.handleInputBlur}
                onCopy={this.handleInputCopy}
                value={formattedNumber}
                label={
                  formattedNumber && formattedNumber !== ""
                    ? this.props.label
                      ? this.props.label
                      : "Customer Number"
                    : null
                }
                placeholder={
                  this.props.label ? this.props.label : "Customer Number"
                }
                variant="outlined"
                disabled={this.props.readOnly}
                fullWidth
                autoFocus={false}
                className={
                  this.props.validStatus === 402
                    ? this.props.classes.rootEror
                    : !this.props.readOnly &&
                      formattedNumber &&
                      formattedNumber !== ""
                    ? this.props.classes.rootFilled
                    : this.props.classes.root
                }
                InputProps={{
                  readOnly: this.props.readOnly,
                  classes2: this.props.classes,
                  disableUnderline: true,
                  startAdornment: this.props.startAdornment ? (
                    <>
                      <span
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        {this.props.startAdornment} +{selectedCountry.dialCode}
                      </span>
                    </>
                  ) : (
                    <span>+{selectedCountry.dialCode}</span>
                  ),
                }}
                inputRef={(el) => (this.numberInputRef = el)}
                color="primary"
                autoComplete="off"
                name={"customer_number"}
              ></TextField>

              {this.props.showValidationMessage &&
                this.props.validStatus === 402 && (
                  <FormHelperText className="text-danger">
                    {this.props.label ? this.props.label : "Customer Number"} is
                    not valid
                  </FormHelperText>
                )}
            </div>
          </div>
        )}
      </>
    );
  }
}
export default withStyles(classes)(PhoneInput);
